<template>
  <basic-dialog :show="show" @close="$emit('close')" :max-width="maxWidth">
    <template v-slot:title>{{ title }}</template>
    <v-tabs v-model="tab" centered>
      <v-tab key="details">Details</v-tab>
      <v-tab key="contents">Contents</v-tab>
      <v-tab-item key="details">
        <v-row>
          <v-col v-if="isNew">
            <destination-list-select
              @onSelect="onDestinationChange"
              :outlined="outlinedInputs"
              :setRoot="true"
            ></destination-list-select>
          </v-col>
          <v-col cols="12" sm="5" class="pb-0">
            <v-text-field
              label="Name"
              v-model="name"
              :outlined="outlinedInputs"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2" class="pb-0">
            <v-text-field
              label="Code"
              v-model="code"
              :outlined="outlinedInputs"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2" class="pb-0">
            <v-text-field
              label="External Code"
              v-model="externalCode"
              :outlined="outlinedInputs"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <brand-list-select
              v-model="brand"
              :outlined="outlinedInputs"
              hide-details
            />
          </v-col>
          <v-col class="pt-0" cols="2">
            <v-switch
              label="Is Default"
              v-model="isDefault"
              hide-details
            ></v-switch>
          </v-col>
          <v-col class="pt-0">
            <v-switch
              label="Not In Use"
              v-model="notInUse"
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item key="contents">
        <template v-if="destinationOwnerId">
          <contents owner-name="DESTINATION" :owner-id="destinationOwnerId" />
        </template>
      </v-tab-item>
    </v-tabs>
    <code v-if="debug">{{ destination }}</code>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onSave">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog";
import DestinationListSelect from "../../shared/DestinationListSelect";
import Contents from "../../shared/contents/Contents";
import BrandListSelect from "../../shared/BrandListSelect.vue";

export default {
  name: "destination-edit-dialog",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => {},
    },
    maxWidth: {
      type: String,
      default: () => "1200px",
    },
  },

  components: {
    BasicDialog,
    DestinationListSelect,
    Contents,
    BrandListSelect,
  },

  data() {
    return {
      debug: false,

      tab: null,
      brand: this.value ? this.value.brand : "",
      name: this.value && this.value.name ? this.value.name : "",
      code: this.value && this.value.code ? this.value.code : "",
      externalCode:
        this.value && this.value.externalCode ? this.value.externalCode : "",
      isDefault: this.value && this.value.isDefault && this.value.isDefault,
      geolocation: "",
      notInUse: this.value && this.value.notInUse ? true : false,
    };
  },

  watch: {
    value(newVal) {
      this.name = newVal.name;
      this.code = newVal.code;
      this.externalCode = newVal.externalCode;
      this.isDefault = newVal.isDefault;
      this.parentId = newVal.parentId;
      this.brand = newVal.brand;
      this.notInUse = newVal.notInUse;
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    destinationOwnerId() {
      return this.value && this.value.id ? this.value.id : null;
    },
    title() {
      return this.value && this.value.id
        ? `Editing - ${this.value.name}`
        : "New Destination";
    },
    isNew() {
      return this.value && this.value.id == "";
    },
    isValid() {
      return this.isNew
        ? this.name != "" && this.parentId != ""
        : this.name != "";
    },
    destination() {
      return {
        id: this.value && this.value.id != "" ? this.value.id : undefined,
        parentId: this.parentId,
        name: this.name,
        code: this.code,
        geolocation: this.geolocation,
        isDefault: this.isDefault,
        brand: this.brand,
        notInUse: this.notInUse,
        externalCode: this.externalCode,
      };
    },
  },

  methods: {
    onSave() {
      this.$emit("input", { ...this.destination });
      this.$emit("save", { ...this.destination });
    },
    onDestinationChange(payload) {
      this.parentId = payload.id;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/destinations/DestinationEditDialog.vue